import {SettingsService} from './../settings.service';
import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import { AuthService } from 'src/app/services';

@Component({
    selector: 'app-advanced',
    templateUrl: './advanced.component.html',
    styleUrls: ['./advanced.component.scss'],
    standalone: false
})
export class AdvancedComponent implements OnInit {

	public clearCache() {
		this._settingsService.clearCache(
			{
				showLoadingIndicator: true
			}
		).subscribe();
		this.authService.ClearLocalStorageItems();
	}

	constructor(
		private _settingsService: SettingsService,
		private _titleService: Title,private authService: AuthService
	) {}

	ngOnInit() {
		this._titleService.setTitle('Advanced');
	}
}
